import Action from '../base/action';

class MediaScreenShow extends Action {
    mediaId;
    show;

    constructor(props) {
        super({...props, className: props.className || props.type + '_class'});
        this.mediaId = props.instanceId;
        this.show = props.show;
    }

    async execute({training}) {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        media.visible = this.show;
    }

    async stop() {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        MediaScreenManager.changeScreenVisibility(media.params.screenID, false);
    }
}

export default MediaScreenShow;
